import NumberBox from "devextreme/ui/number_box";
NumberBox.defaultOptions({
    options: {
        step: 0
    }
});